import { RequestModel } from "./models/RequestModel";
import axios from "axios";
import { executeApiRequest } from "@/plumbing/http/apiClient";
import { getStatus, RequestStatus } from "@/api/Requests/models/RequestModel";

export type ListRequestsRequest = {
  startAt: Date;
  endAt: Date;
  wasteStreamIds?: number[];
  suburbs?: string[];
  streets?: string[];
  requestTypes: string[];
  includeComplete?: boolean;
  includeInProgress?: boolean;
  includePending?: boolean;
  referenceNumber?: string;
};

export type ListRequestsResponse = {
  requests: RequestModel[];
};

export const listRequests = async (request: ListRequestsRequest) => {
  const response = await executeApiRequest(
    () => axios.post<ListRequestsResponse>("/requests", request, { withCredentials: true }),
    false
  );

  response?.data.requests.forEach(r => (r.action = getStatus(r) == RequestStatus.Pending ? 1 : 0));

  return response?.data;
};
